<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb name="Transaction Report" :breadcrumb="breadcrumb"/>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Generate Report</h4>
                </div>
                <div class="card-body">
                  <Form class="form form-horizontal" v-slot="{ meta,errors  }" @submit="sendCall">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Transaction Type</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <Field as="select"  rules="required" name="transactionTypeId" class="form-control" :class="(errors.type && !meta.valid && meta.touched)? 'is-invalid': ''">
                                <option value>Select Type </option>
                                <option :key="transactionIndex" :value="transactionItem.id" v-for="(transactionItem, transactionIndex) in transactionTypes ">
                                  {{transactionItem.name}}
                                </option>
                              </Field>
                            </div>
                            <ErrorMessage as="small" class="text-danger" name="transaction_type"/>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Channel</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <Field as="select"    name="channelId" class="form-control" :class="(errors.type && !meta.valid && meta.touched)? 'is-invalid': ''">
                                <option value>Select Channel</option>
                                <option :key="channelIndex" :value="channel.id" v-for="(channel, channelIndex) in channelList">
                                  {{ channel.name   }}
                                </option>
                              </Field>
                            </div>
                            <ErrorMessage as="small" class="text-danger" name="channelId"/>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Start Date</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="">
                              <datepicker :upperLimit="upperLimitDate" v-model="startDate" class="form-control"/>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>End Date</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="">
                              <datepicker :upperLimit="upperLimitDate" v-model="endDate" class="form-control"/>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Export As</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <Field as="select"  rules="required" name="exportAs" class="form-control" :class="(errors.type && !meta.valid && meta.touched)? 'is-invalid': ''">
                                <option value>Select Type</option>
<!--                                <option value="pdf">Pdf</option>-->
                                <option value="excel">Excel</option>
                              </Field>
                            </div>
                            <ErrorMessage as="small" class="text-danger" name="exportAs"/>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Limit</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <Field
                                  class="form-control"
                                  type="text"
                                  name="limit"
                                  :class="(errors.limit && !meta.valid && meta.touched)? 'is-invalid': ''"
                              >
                              </Field>
                            </div>
                            <ErrorMessage as="small" class="text-danger" name="limit"/>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-9 offset-sm-3">
                        <Button class="btn btn-primary mr-1" :loading="loader">Generate</Button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<!--<script setup>-->
<!--import Datepicker from 'vue3-datepicker'-->
<!--import { ref } from 'vue'-->
<!--</script>-->

<script>
import Datepicker from 'vue3-datepicker'
import { ref } from 'vue'
import Button from "@/components/common/Button";
import SearchSelect from "@/components/common/SearchSelect.vue";
export default {
  components: {SearchSelect, Button,Datepicker},
  mounted() {

    this.getTransactionTypes()


  },
  data() {
    return {
      selectedChannel:null,
      breadcrumb: [
        {name: 'App'},
        {name: 'Report'},
        {name: 'Transaction'},
      ],
      loader: false,
      currencyLoader: true,
      emailOrPhone: '',
      selectedCurrency: null,
      currencyData: [],
      startDate: ref(new Date()),
      endDate: ref(new Date()),
      transactionTypes : [],
      channelList:[],

    }
  },
  methods: {
    getChannelData() {
      this.makeRequest('post', 'v1/get-stores', {}, {}, false).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          let responseData = callResponse.response.data.data
          if (code == 200) {
            if(responseData){
              if(responseData.channels){
                this.channelList = responseData.channels
              }
            }

          }

        }


      });
    },
    getTransactionTypes(){
      this.makeRequest('post', 'v1/transaction-types', {}, {}, false).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          let responseData = callResponse.response.data.data
          if (code == 200) {
            this.transactionTypes = responseData
          }
        }
        this.getChannelData()
      });
    },
    formatDate(val){
      let date = new Date(val)
      let day = ("0" + date.getDate()).slice(-2)
      let month = ("0" + (date.getMonth() + 1)).slice(-2)
      let year= date.getFullYear()

      let formatted_date = year+'-'+month+'-'+day
      return formatted_date
    },
    sendCall(values, { resetForm }) {
      let data = values
      data.reportType = 'transaction'
      data.fromDate = this.formatDate(this.startDate)
      data.toDate = this.formatDate(this.endDate)

      if(typeof(data.limit) == 'undefined'){
        delete data.limit
      }
      this.loader = true
      this.makeRequest('post', 'v1/generate-report', data).then(callResponse => {

        this.loader = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            let url = callResponse.response.data.data.url
            window.open(url, '_blank').focus();
          }
        }
        resetForm();
        this.startDate = ref(new Date())
        this.endDate = ref(new Date())
      });

    },
    getCurrencyData() {
      this.makeRequest('post', 'v1/get-payment-methods', {type: 'PAYMENT_LINK'}, {}, false).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          let responseData = callResponse.response.data.data
          if (code == 200) {
            this.currencyData = responseData
            this.selectedCurrency = responseData[0].id
          }
        }

        this.currencyLoader = false

      });
    },
  },
}
</script>

